import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate  } from "react-router-dom";
import Landing from "@/pages/Landing";
import RadAgent from "@/pages/RadAgent";
import RadScribe from "@/pages/RadScribe";
import CustomCursor from "@/components/CustomCursor";

function App() {
  return (
    <div className="App">
      <CustomCursor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/radagent" element={<RadAgent />} />
          <Route path="/radscribe" element={<RadScribe />} />
 {/* Redirect all invalid URLs to homepage */}
          <Route path="*" element={<Navigate to="/" replace />} />
          
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
